window.M = window.M || {};


window.M.CronTab = (function() {
    
    function numericSort (a,b) {
        an = parseInt(a,10);
        bn = parseInt(b,10);
        
        if(isNaN(an)) {
            an = a.charCodeAt(0);
        }
        
        if(isNaN(bn)) {
            bn = b.charCodeAt(0);
        }
        
        return an-bn;
    }
    
    function expandrange(range, vals) {
        if(range == "*") {
            if(Array.isArray(vals)) return vals;
            return [];
        }
        range = range.split(",");
        
        var ret = [];
        
        for(var i = 0; i < range.length; i++) {
            var span = /^(\d+)-(\d+)$/.exec(range[i]);
            
            if(span) {
                console.log("Range from " + span[1] + " to " + span[2]);
                for(var j = parseInt(span[1], 10); j <= parseInt(span[2], 10); j++) {
                    console.log("pushing " + j);
                    ret.push("" + j);
                    
                }
            } else
            {
                ret.push(range[i]);
            }
        }
        
        ret.sort(numericSort);
        return ret;
    }
    
    function condenserange(values, vals) {
        if(!Array.isArray(values)) {
            values = [values];
        }
        if(!values.length) return "*";
        
        if(!Array.isArray(vals) && typeof(vals) == "object") {
            values = values.map(function(v) {
                var v2 = _.findKey(vals, function(k) {return k == v; });
                if(typeof(v2) !== "undefined")
                    return v2;
                else
                    return v;
            });
        
            vals = Object.keys(vals);
        }
        
        
        values.sort(numericSort);
        
        var ret = [];
        var tmpStart = null;
        var tmpCur = null;
        
        for(var i = 0; i < values.length; i++) {
            var v = parseInt(values[i],10);
            if(isNaN(v)) v = values[i];
            
            if(null !== tmpStart) {
                if(v == tmpCur + 1) {
                    tmpCur = v;
                    continue;
                } else {
                    if(tmpCur != tmpStart) {
                        ret.push(tmpStart + "-" + tmpCur);
                    } else {
                        ret.push(tmpStart);
                    }
                    tmpStart = v;
                    tmpCur = v;
                }
            } else {
                tmpStart = v;
                tmpCur = v;
            }
        }
        
        if(tmpCur != tmpStart) {
            ret.push(tmpStart + "-" + tmpCur);
        } else {
            ret.push(tmpStart);
        }
        
        return ret.join(',');
    }
    
     function explode (cronexpr) {
        cronexpr = cronexpr || "";
        var parts = cronexpr.split(" ");
        var ret = {
            seconds: parts[0] || "0",
            minutes: parts[1] || "*",
            hours: parts[2] || "*",
            daysofmonth: expandrange(parts[3] || "?", daynums),
            months:      expandrange(parts[4] || "*", monthnames),
            daysofweek:  expandrange(parts[5] || "*", daynames),
            years:       parts[6] || "*" 
        };
        
        return ret;
    }
    
    function implode (cron) {
        var ret = [];
        
        ret.push(cron.seconds);
        ret.push(cron.minutes);
        ret.push(cron.hours);
        ret.push(condenserange(cron.daysofmonth, daynums));
        ret.push(condenserange(cron.months, monthnames));
        ret.push(condenserange(cron.daysofweek, daynames));
        ret.push(cron.years);
        
        return ret.join(" ");
    }
    
    var daynums = {};
    for(var i = 1; i <= 31; i++) {
        daynums["" + i] = "" + i;
    }
    daynums.L = "Last";
    var daynames = _.zipObject(_.range(1,8).map(x => "" + x), ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"]);
    var monthnames = _.zipObject(_.range(1,13).map(x => "" + x),["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT","NOV","DEC"]);
    

    return {
        explode:explode,
        implode:implode,
        expandrange: expandrange,
        condenserange: condenserange,
        daynums: daynums,
        daynames: daynames,
        monthnames: monthnames,
        numericSort: numericSort
    };
})();